import BaseService from './BaseService';
import apiClient from '../plugins/axios';

/**
 * LiveKit Service
 */
class LivekitService extends BaseService {
  constructor() {
    super('livekit');
  }

  /**
   * Get LiveKit token
   * @param {string} room - Room name (required)
   * @param {string} [identity] - User identity (optional)
   * @param {string} [phone] - Phone number (optional)
   * @returns {Promise<Object>}
   */
  async getToken(room, identity, phone) {
    try {
      const params = new URLSearchParams({ room });

      if (identity) params.append('identity', identity);
      if (phone) params.append('phone', phone);

      const response = await apiClient.get(
        `/livekit/token?${params.toString()}`,
      );

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Dispatch agent to a room
   * @param {Object} data
   * @param {string} data.room - Room name (required)
   * @param {string} [data.phone]
   * @param {string} [data.agent_name]
   * @param {string} [data.agent_id]
   * @returns {Promise<Object>}
   */
  async dispatchAgent(data) {
    try {
      const response = await apiClient.post(
        '/livekit/dispatch',
        data,
      );

      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }
}

export default new LivekitService();
